module.exports = __webpack_public_path__ + "img/Group 4641_copy2.6cc38de1.png";